import icons from 'url:../../img/icons.svg';

export default class parentView {
  _data;
  /**
   *
   * @param {ssdf} data
   */

  render(data) {
    // if (!data) return this.showError('ERROR');
    this._data = data;
    const recipeMarkup = this.generateMarkup();
    this.clear();
    this._parentElement.insertAdjacentHTML('afterbegin', recipeMarkup);
  }
  update(data) {
    this._data = data;
    const newMarkup = this.generateMarkup();

    const newDOM = document.createRange().createContextualFragment(newMarkup);
    const newElements = Array.from(newDOM.querySelectorAll('*'));
    const curElements = Array.from(this._parentElement.querySelectorAll('*'));

    newElements.forEach((newEl, i) => {
      const curEl = curElements[i];
      // console.log(curEl, newEl.isEqualNode(curEl));

      // Updates changed TEXT
      if (
        !newEl.isEqualNode(curEl) &&
        newEl.firstChild?.nodeValue.trim() !== ''
      ) {
        // console.log('💥', newEl.firstChild.nodeValue.trim());
        curEl.textContent = newEl.textContent;
      }

      // Updates changed ATTRIBUES
      if (!newEl.isEqualNode(curEl))
        Array.from(newEl.attributes).forEach(attr =>
          curEl.setAttribute(attr.name, attr.value)
        );
    });
  }

  clear() {
    this._parentElement.innerHTML = '';
  }
  loadingSpinner() {
    const markupSpinner = `<div class="spinner">
      <svg>
        <use href="${icons}#icon-loader"></use>
      </svg>
    </div>`;
    this.clear();
    this._parentElement.insertAdjacentHTML('afterbegin', markupSpinner);
  }
  showError(message) {
    const err = `<div class="error">
      <div>
        <svg>
          <use href="${icons}#icon-alert-triangle"></use>
        </svg>
      </div>
      <p>${message}</p>
    </div>`;
    this.clear();
    this._parentElement.insertAdjacentHTML('beforebegin', err);
  }
}
